// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__dOf1V","header":"Alert_header__bgOT0","severity":"Alert_severity__T4RrN","title":"Alert_title__j2LH1"};